module.exports = __webpack_public_path__ + "img/Progress-Report-4-mobile.4c8df0dc.png";